import * as actions from './actions'
import { NAME } from './constants'
import reducer from './reducer'
import * as selectors from './selectors'

const index = {
  NAME,
  reducer,
  actions,
  selectors,
}

export default index
